import { Component, Input } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TranslateModule } from '@ngx-translate/core';

import { FlexModule } from '@angular/flex-layout';
import { IVaccinationDetailed } from '../../../../../../../interfaces/Vaccination/IVaccinationDetailed';

@Component({
  selector: 'app-vaccination-expand',
  standalone: true,
  templateUrl: './vaccination-expand.component.html',
  styleUrls: ['./vaccination-expand.component.css'],
  imports: [NzLayoutModule, NzTableModule, TranslateModule, FlexModule],
})
export class VaccinationExpandComponent {
  @Input() item: IVaccinationDetailed = {};
}
